



















import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import {cloneDeep} from 'lodash';

interface Description {
    Id: number;
    Description: string;
}

@Component({
    inheritAttrs: false,
})
export default class CCombobox extends Vue {
    @Prop({required: true}) value!: number;
    @Prop({required: true}) requestApi!: string;
    @Prop({default: () => ({})}) requestQuery!: {
        [key: string]: string | number;
    };
    @Prop({default: true, type: Boolean}) showChangeState!: boolean;
    @Prop() initialValue!: number | undefined;
    @Prop() rules!: any[];
    @Prop({default: false, type: Boolean}) maskValue!: boolean;
    @Prop({default: 'plywood lighten-1', type: String}) color!: string;

    private loading: boolean = false;
    private items: Description[] = [];
    private internalValue: any[] = [];
    private localInitialValue: number | null = null;

    get selectClasses() {
        const classes: string[] = [];
        if (this.value != this.realInitialValue && this.showChangeState) classes.push('changed');
        return classes;
    }

    get listeners() {
        return Object.assign({}, this.$listeners, {
            input: (value: any) => this.$emit('input', this.maskValue ? this.getMask(value) : value),
            change: (value: any) => this.$emit('input', this.maskValue ? this.getMask(value) : value),
        });
    }

    get realInitialValue() {
        return typeof this.initialValue != 'undefined' ? this.initialValue : this.localInitialValue;
    }

    get realRules() {
        return this.rules ? this.rules : [];
    }

    get realValue() {
        return this.maskValue ? this.internalValue : this.value;
    }

    created() {
        this.getDescriptions();
        this.localInitialValue = this.value;
    }

    async getDescriptions() {
        this.loading = true;
        try {
            const {data} = await this.$http.get(`${this.requestApi}/GetDescriptions`, {
                params: {
                    ...this.requestQuery,
                },
            });
            this.items = data;
            if (this.maskValue) {
                this.internalValue = this.items
                    .filter((item: Description) => Boolean(this.value & item.Id))
                    .map((item: Description) => item.Id);
            }
        } finally {
            this.loading = false;
        }
    }

    getMask(value: number[]) {
        return value.reduce((sum: number, curValue: number) => sum + curValue, 0);
    }
}
